// extracted by mini-css-extract-plugin
export default {"avatarError":"AvatarCard_avatarError__tu6vg","header":"AvatarCard_header__UixoC","card":"AvatarCard_card__kHAkq","btn":"AvatarCard_btn__WQCdU"};